<script setup lang="ts">
import { computed } from 'vue';
import { getDefaultDateFormat } from '@Helpers';

const props = defineProps<{
  field: any;
  rowData: any;
  settings: any;
}>();

const receiptLabel = computed(() => {
  if (props.field) return props.field;
  const formattedDate = getDefaultDateFormat(props.rowData['created_at']);

  const rowDate = !formattedDate ? '' : formattedDate.replace(/\//g, '');
  const animalId = props.rowData['animal_seq_id'];
  const citationId = props.rowData['citation_seq_id'];
  const donationId = props.rowData['donation_seq'];
  const productId = props.rowData['product_seq'];
  const serviceId = props.rowData['service_seq'];
  return `R${rowDate}-${animalId || citationId || donationId || productId || serviceId}`;
});
</script>

<template>
  <p>{{ receiptLabel || '-' }}</p>
</template>
